var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "csh" },
    [
      _c(
        "div",
        { staticClass: "bar", style: { backgroundColor: _vm.backgroundColor } },
        [
          _c("div", { staticClass: "status" }, [
            _vm._v(" " + _vm._s(_vm.candidate.status.name) + " "),
            _c(
              "svg",
              {
                directives: [
                  {
                    name: "b-popover",
                    rawName: "v-b-popover.html",
                    value: {
                      content: `Изменить статус`,
                      trigger: "hover blur",
                      container: "#app",
                      placement: "top",
                    },
                    expression:
                      "{\n          content: `Изменить статус`,\n          trigger: 'hover blur',\n          container: '#app',\n          placement: 'top',\n        }",
                    modifiers: { html: true },
                  },
                ],
                attrs: {
                  width: "14",
                  height: "14",
                  viewBox: "0 0 14 14",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
                on: { click: _vm.updateCandidateStatus },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M0 11.8123C0 12.3645 0.447715 12.8123 1 12.8123C1.55228 12.8123 2 12.3645 2 11.8123H0ZM1 8.81226V7.81226C0.447715 7.81226 0 8.25997 0 8.81226H1ZM4 9.81226C4.55228 9.81226 5 9.36454 5 8.81226C5 8.25997 4.55228 7.81226 4 7.81226V9.81226ZM14 1.8125C14 1.26022 13.5523 0.812502 13 0.812502C12.4477 0.812502 12 1.26022 12 1.8125H14ZM13 4.8125V5.8125C13.5523 5.8125 14 5.36479 14 4.8125H13ZM10 3.8125C9.44771 3.8125 9 4.26022 9 4.8125C9 5.36479 9.44771 5.8125 10 5.8125V3.8125ZM13.9256 9.18537C14.1079 8.66403 13.833 8.09365 13.3116 7.91139C12.7903 7.72913 12.2199 8.00401 12.0376 8.52536L13.9256 9.18537ZM2.98648 9.03626C2.74671 8.53874 2.14902 8.32979 1.6515 8.56956C1.15397 8.80933 0.945023 9.40702 1.18479 9.90455L2.98648 9.03626ZM0.574402 4.62713C0.392144 5.14848 0.667027 5.71886 1.18837 5.90112C1.70972 6.08338 2.2801 5.80849 2.46236 5.28715L0.574402 4.62713ZM11.5135 4.77624C11.7533 5.27377 12.351 5.48272 12.8485 5.24295C13.346 5.00318 13.555 4.40548 13.3152 3.90796L11.5135 4.77624ZM2 11.8123V8.81226H0V11.8123H2ZM1 9.81226H4V7.81226H1V9.81226ZM12 1.8125V4.8125H14V1.8125H12ZM13 3.8125H10V5.8125H13V3.8125ZM12.0376 8.52536C11.7174 9.44136 11.1327 10.2418 10.3576 10.8256L11.5607 12.4232C12.6518 11.6016 13.4748 10.4748 13.9256 9.18537L12.0376 8.52536ZM10.3576 10.8256C9.58242 11.4093 8.65157 11.75 7.68275 11.8047L7.79546 13.8015C9.15922 13.7245 10.4695 13.2449 11.5607 12.4232L10.3576 10.8256ZM7.68275 11.8047C6.71393 11.8594 5.75065 11.6256 4.91472 11.1328L3.89906 12.8557C5.07575 13.5494 6.43171 13.8785 7.79546 13.8015L7.68275 11.8047ZM4.91472 11.1328C4.07879 10.64 3.40776 9.91041 2.98648 9.03626L1.18479 9.90455C1.7778 11.135 2.72237 12.162 3.89906 12.8557L4.91472 11.1328ZM2.46236 5.28715C2.78259 4.37115 3.36725 3.57067 4.14241 2.98695L2.93932 1.38928C1.84817 2.21094 1.02517 3.33773 0.574402 4.62713L2.46236 5.28715ZM4.14241 2.98695C4.91758 2.40323 5.84843 2.06249 6.81725 2.0078L6.70454 0.0109785C5.34078 0.0879575 4.03048 0.567608 2.93932 1.38928L4.14241 2.98695ZM6.81725 2.0078C7.78607 1.95311 8.74935 2.18694 9.58528 2.67972L10.6009 0.956806C9.42425 0.26315 8.06829 -0.0660006 6.70454 0.0109785L6.81725 2.0078ZM9.58528 2.67972C10.4212 3.1725 11.0922 3.9021 11.5135 4.77624L13.3152 3.90796C12.7222 2.67747 11.7776 1.65046 10.6009 0.956806L9.58528 2.67972Z",
                    fill: "#8E9CBB",
                  },
                }),
              ]
            ),
          ]),
          _c(
            "div",
            { staticClass: "bar__row" },
            [
              _c("CandidatesStatusIcon", {
                staticClass: "status-icon",
                attrs: {
                  "scheduled-date-time": {
                    time: _vm.candidate.statusTime,
                    date: _vm.candidate.statusDate,
                  },
                  status: _vm.candidate.state,
                },
              }),
              _vm.candidateStatusScheduledDate
                ? _c("ScheduledDate", {
                    staticClass: "scheduled-date",
                    attrs: {
                      date: _vm.candidateStatusScheduledDate,
                      "status-id": _vm.candidate.status.id,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm.candidate.dateOfStatusChange
            ? _c("div", { staticClass: "days-in-status" }, [
                _c(
                  "svg",
                  {
                    directives: [
                      {
                        name: "b-popover",
                        rawName: "v-b-popover.html",
                        value: {
                          container: "#app",
                          trigger: "hover blur",
                          content: `Количество дней в статусе: ${_vm.getCalculatedDaysFromStatusChangeDate(
                            _vm.candidate.dateOfStatusChange
                          )}`,
                          placement: "top",
                        },
                        expression:
                          "{\n          container: '#app',\n          trigger: 'hover blur',\n          content: `Количество дней в статусе: ${getCalculatedDaysFromStatusChangeDate(\n            candidate.dateOfStatusChange,\n          )}`,\n          placement: 'top',\n        }",
                        modifiers: { html: true },
                      },
                    ],
                    attrs: {
                      width: "14",
                      height: "13",
                      viewBox: "0 0 14 13",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M10 1V3M4 1V3M2.77778 2H11.2222C12.2041 2 13 2.79594 13 3.77778V10.2222C13 11.2041 12.2041 12 11.2222 12H2.77778C1.79594 12 1 11.2041 1 10.2222V3.77778C1 2.79594 1.79594 2 2.77778 2Z",
                        stroke: "#8E9CBB",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    }),
                  ]
                ),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.getCalculatedDaysFromStatusChangeDate(
                        _vm.candidate.dateOfStatusChange
                      )
                    )
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.candidate.status.comment
            ? _c("div", { staticClass: "status-comment" }, [
                _c(
                  "svg",
                  {
                    staticClass: "c-button-icon_stroked",
                    attrs: {
                      width: "15",
                      height: "15",
                      viewBox: "0 0 16 17",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M13.4647 1.00024H2.49575C1.67075 1.00024 1 1.67099 1 2.49599V9.47673C1 10.3017 1.67075 10.9725 2.49575 10.9725H5.98612V14.7191C5.98612 14.9481 6.24787 15.0813 6.43251 14.9458L9.97501 10.9725H13.4647C14.2897 10.9725 14.9604 10.3017 14.9604 9.47673V2.49599C14.9604 1.67099 14.2897 1.00024 13.4647 1.00024Z",
                        stroke: "#8E9CBB",
                        "stroke-width": "2",
                      },
                    }),
                  ]
                ),
                _c("div", { staticClass: "status-comment__comment" }, [
                  _vm._v(" " + _vm._s(_vm.candidate.status.comment) + " "),
                ]),
                _c(
                  "span",
                  {
                    staticClass: "status-comment__button",
                    on: {
                      click: function ($event) {
                        return _vm.openCommentModal(
                          _vm.candidate.status.comment
                        )
                      },
                    },
                  },
                  [_vm._v(" Показать ")]
                ),
              ])
            : _vm._e(),
          _c("div", { staticClass: "accountable" }, [
            _c("img", {
              attrs: { height: "34", width: "34", src: _vm.accountableAvatar },
            }),
            _c("div", { staticClass: "accountable__info" }, [
              _vm.candidate.accountable
                ? _c(
                    "a",
                    {
                      staticClass: "accountable__name",
                      attrs: { href: _vm.linkToWorker, target: "_blank" },
                    },
                    [_vm._v(" " + _vm._s(_vm.candidate.accountable.name) + " ")]
                  )
                : _c("div", [_vm._v("Не назначен")]),
              _c("div", { staticClass: "accountable__label" }, [
                _vm._v("Ответственный за кандидата"),
              ]),
            ]),
          ]),
        ]
      ),
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "header__employee" }, [
          _c(
            "div",
            {
              directives: [{ name: "viewer", rawName: "v-viewer" }],
              staticClass: "header__employee__avatar",
            },
            [
              _c("img", {
                attrs: {
                  src: _vm.candidate.photo
                    ? _vm.candidate.photo
                    : _vm.defaultAvatar,
                },
                on: { error: _vm.replaceImageOnErrorLoad },
              }),
            ]
          ),
          _c("div", { staticClass: "header__employee__info" }, [
            _c(
              "div",
              { staticClass: "header__employee__info__fullname" },
              [
                _c(
                  "div",
                  { staticClass: "header__employee__info__fullname__text" },
                  [_vm._v(" " + _vm._s(_vm.candidate.fio) + " ")]
                ),
                _c("CandidatesWorksheetStatus", {
                  attrs: {
                    candidate: _vm.candidate,
                    "with-link": !_vm.personal,
                  },
                }),
                _c("CandidatesSourceIcon", {
                  attrs: { "source-id": _vm.candidate.source.id },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "header__employee__info__block" }, [
              _vm.candidate.post
                ? _c(
                    "div",
                    { staticClass: "header__employee__info__position" },
                    [_c("div", [_vm._v(_vm._s(_vm.candidate.post))])]
                  )
                : _vm._e(),
              _vm.candidate.filial
                ? _c("div", { staticClass: "header__employee__info__filial" }, [
                    _vm._v(
                      " " + _vm._s(_vm.candidate.filial.filial_name) + " "
                    ),
                  ])
                : _vm._e(),
              _vm.candidate.phone || _vm.candidate.email
                ? _c(
                    "div",
                    { staticClass: "header__employee__info__phone-and-email" },
                    [
                      _vm._v(" " + _vm._s(`${_vm.candidate.phone}`)),
                      _vm.candidate.email
                        ? _c("span", [
                            _vm._v(", " + _vm._s(`${_vm.candidate.email}`)),
                          ])
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "header__buttons" },
          [
            _vm.candidateComment
              ? _c(
                  "BubbleComment",
                  {
                    staticClass: "header__buttons__top__comment__bubble",
                    attrs: { "edit-permission": true },
                    on: {
                      goToPreview: function ($event) {
                        return _vm.openCommentModal(_vm.candidateComment)
                      },
                      goToEdit: function ($event) {
                        _vm.displayWorkerCommentModal = true
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.candidateComment) + " ")]
                )
              : _c("Button", {
                  attrs: { size: "small", icon: "comment" },
                  on: {
                    click: function ($event) {
                      _vm.displayWorkerCommentModal = true
                    },
                  },
                }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "layout-header-action-dropdown head__actions" },
          [
            _c("div", {
              staticClass: "c-button__dropdown__container__overlay",
              class: {
                "c-button__dropdown__container__overlay__active":
                  _vm.isActiveDropdown,
              },
              on: {
                click: function ($event) {
                  _vm.isActiveDropdown = false
                },
              },
            }),
            _c(
              "div",
              {
                staticClass: "c-button c-button_with-icon c-button_responsive",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "c-button__wrapper",
                    class: {
                      "c-button__wrapper__active": _vm.isActiveDropdown,
                    },
                    on: {
                      click: function ($event) {
                        _vm.isActiveDropdown = !_vm.isActiveDropdown
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "c-button__label__left" }, [
                      _vm._v("Действия"),
                    ]),
                    _c(
                      "div",
                      { staticClass: "c-button__icon__right" },
                      [_c("Icon", { attrs: { icon: "arrow" } })],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "c-button__dropdown__container c-button__dropdown__container__left",
                        class: {
                          "c-button__dropdown__container__active":
                            _vm.isActiveDropdown,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "c-button__dropdown__container__list",
                          },
                          [
                            !_vm.personal
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-button__dropdown__container__list__item",
                                    on: { click: _vm.goToWorksheet },
                                  },
                                  [
                                    _c("CandidatesWorksheetStatus", {
                                      attrs: { candidate: _vm.candidate },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-button__dropdown__container__list__item__label",
                                      },
                                      [_vm._v("Анкета кандидата")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-button__dropdown__container__list__item",
                                on: { click: _vm.edit },
                              },
                              [
                                _c("Icon", { attrs: { icon: "edit" } }),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-button__dropdown__container__list__item__label",
                                  },
                                  [_vm._v("Редактировать")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-button__dropdown__container__list__item",
                                on: { click: _vm.deleteCandidate },
                              },
                              [
                                _c("Icon", {
                                  attrs: { icon: "trash", color: "secondary" },
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-button__dropdown__container__list__item__label",
                                  },
                                  [_vm._v("Удалить")]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]),
      _c("CandidateChangeStatus", {
        ref: "changeStatusModal",
        attrs: { "candidate-data": _vm.candidate },
      }),
      _c("CommentModal", { ref: "commentModal" }),
      _vm.displayWorkerCommentModal
        ? _c("WorkerCommentModal", {
            ref: "workerCommentModal",
            attrs: {
              comment: _vm.candidateComment,
              "handle-save-outside": true,
            },
            on: {
              "on-save": _vm.onCommentSave,
              close: function ($event) {
                _vm.displayWorkerCommentModal = false
              },
            },
          })
        : _vm._e(),
      _c("Confirm", { ref: "confirm", attrs: { mode: "danger" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }